module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rechargeLocUrl) ? _c('div', [_c('a', {
    staticClass: "el-button buy-btn el-button--primary",
    attrs: {
      "type": "primary",
      "target": "_blank",
      "href": _vm.rechargeLocUrl
    },
    on: {
      "click": _vm.rechargeSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('payNow')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cc41eff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/recharge/RechargeByLoc.vue
// module id = 372
// module chunks = 0